import React from 'react'

export default function Chats() {
  return <h1>this is Chats</h1>
}
